import {call, put, takeLatest} from 'redux-saga/effects'
import {DCore} from '../config'


import {
    FETCH_USER_BILLS,
    userBillsReceived,
    FETCH_BILLER_DETAILS,
    billerDetailsReceived,
    startLoading,
    stopLoading
} from '../actions'

import {
    BILLER_DETAILS_LOADING_ID,
    FETCH_BILLERS_LOADING_ID
} from '../store/loaders'



function * fetchUserBillers (paylaod){
    yield put(startLoading({id:FETCH_BILLERS_LOADING_ID}))
    try{
       const response=  yield call(DCore.get, `/payments/billing/${paylaod.data}`)
       yield put(stopLoading({id:FETCH_BILLERS_LOADING_ID}))
        yield put (userBillsReceived(response.data))

    }catch(e){
        yield put(stopLoading({id:FETCH_BILLERS_LOADING_ID}))
        console.log("some thing went wrong", e)
    }
}

function * fetchBillerDetails (paylaod){
    yield put(startLoading({id:BILLER_DETAILS_LOADING_ID}))
    try{
       const response=  yield call(DCore.get, `/payments/bill/${paylaod.data}`)
        yield put(stopLoading({id:BILLER_DETAILS_LOADING_ID}))
        yield put (billerDetailsReceived(response.data))

    }catch(e){
        yield put(stopLoading({id:BILLER_DETAILS_LOADING_ID}))
        console.log("some thing went wrong", e)
    }
}


export function * userBillsSaga(){
    yield takeLatest(FETCH_USER_BILLS,fetchUserBillers)
    yield takeLatest(FETCH_BILLER_DETAILS,fetchBillerDetails)
}